export enum FlameTiers {
  LIGHT = 'LIGHT',
  SPARK = 'SPARK',
  SMOKE = 'SMOKE',
  FIRE = 'FIRE',
  FLAME = 'FLAME',
}

export type FlameTier = keyof typeof FlameTiers

export enum TierAccessTypes {
  SURPRISE_LOTTERY = 'surprise_lottery',
  FCFS_LOTTERY = 'fcfs_lottery',
  GUARANTEED = 'guaranteed'
}

